import { Card } from 'antd';
import Item from './property-list-item';


function PropertyList({ items, showEmptyValues = false, nameStyle = {}, valueStyle = {} }) {
  if (!Array.isArray(items)) return null;

  return (
    <Card size="small">
      {
        items
          .filter(
            item => !!item && !!item.name && item.value !== null && item.value !== undefined && (!!item.value || typeof item.value === "boolean" || showEmptyValues)
          )
          .map(item => <Item key={item.name} nameStyle={nameStyle} valueStyle={valueStyle} {...item} />)
      }
    </Card>
  )
}

export default PropertyList;
